/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Venue_AllInputs */

const cs_calendar_venue_all = /** @type {(inputs: Calendar_Venue_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny pobočky`)
};

const en_calendar_venue_all = /** @type {(inputs: Calendar_Venue_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All branches`)
};

/**
* | output |
* | --- |
* | "All branches" |
*
* @param {Calendar_Venue_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_venue_all = /** @type {((inputs?: Calendar_Venue_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Venue_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_venue_all(inputs)
	return cs_calendar_venue_all(inputs)
});